










import Vue from 'vue';
import {Component} from "vue-property-decorator";
import AsiPageTitle from "@/components/common/AsiPageTitle.vue";
import {Icon} from "@/helpers/icons";
import AsiContentContainer from "@/components/common/AsiContentContainer.vue";
import ReportList from "@/components/report/ReportList.vue";
import ReportCreateDialog from "@/components/report/ReportCreateDialog.vue";
import {Permissions} from "@/helpers/constants";
import CompanySimple from "@/models/company/CompanySimple";

@Component({
	components: {ReportCreateDialog, ReportList, AsiContentContainer, AsiPageTitle}
})
export default class Reports extends Vue {

	private icons = Icon;
	private createDialogOpen = false;

	private get isOffice(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightOffice);
	}

	private get isCustomer(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightCustomer);
	}

	private get company(): CompanySimple | null {
		return this.isCustomer ? this.$store.state.user.loggedInUserCompany : null;
	}

}
